import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import axios from 'axios';
import { BASE_URL } from '../../App';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const SCR_Pending_Count = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(BASE_URL + '/serviceclaim');
        console.log("Full API Response:", response);
        if (response.data && response.data.data) {
          console.log("Fetched Data:", response.data.data);
          setTableData(response.data.data);
        } else {
          console.log('No data found in response');
          setTableData([]);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
        Swal.fire('Error', 'Could not fetch data from the server.', 'error');
      }
    };

    fetchData();
  }, []);

  const formatCurrency = (amount) => {
    if (amount == null || isNaN(amount)) {
      return "0.00"; 
    }
    const numAmount = Number(amount); 
    return numAmount.toFixed(2).toLocaleString();
  };

  const downloadExcel = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You are about to download the data as an Excel file.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, download it!',
    }).then((result) => {
      if (result.isConfirmed) {
        const ws = XLSX.utils.json_to_sheet(tableData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Pending Claims');
        XLSX.writeFile(wb, 'service_claim_pending_count.xlsx');
        Swal.fire('Downloaded!', 'Your file has been downloaded.', 'success');
      }
    });
  };

  return (
    <div style={{ padding: '20px' }}>
      <button
        onClick={downloadExcel}
        style={{
          marginBottom: '20px',
          backgroundColor: 'green',
          color: 'white',
          border: 'none',
          padding: '10px 20px',
          cursor: 'pointer',
          borderRadius: '5px',
        }}
      >
        Download Excel
      </button>

      {loading ? (
        <div>Loading...</div>
      ) : (
        <div style={{ maxHeight: '500px', overflowY: 'auto', marginTop: '20px' }}>
          <TableContainer component={Paper} style={{ maxHeight: '400px' }}>
            <Table stickyHeader aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center" style={{ backgroundColor: '#1976d2', color: 'white' }}>
                    Branch Code
                  </TableCell>
                  <TableCell align="center" style={{ backgroundColor: '#1976d2', color: 'white' }}>
                    Current Approval Level
                  </TableCell>
                  <TableCell align="center" style={{ backgroundColor: '#1976d2', color: 'white' }}>
                    Pending
                  </TableCell>
                  <TableCell align="right" style={{ backgroundColor: '#1976d2', color: 'white' }}>
                    Total Amount
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No data available
                    </TableCell>
                  </TableRow>
                ) : (
                  tableData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{row.BRANCH_CODE}</TableCell>
                      <TableCell align="center">{row.CURRENT_APPROVAL_LEVEL}</TableCell>
                      <TableCell align="center">{row.PENDING}</TableCell>
                      <TableCell align="right">{formatCurrency(row.TOTAL_AMOUNT)}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}
    </div>
  );
};

export default SCR_Pending_Count;















